"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partnerNotice = void 0;
exports.partnerNotice = function (axios) {
    return {
        getPartnerNotices: function (GetPartnerNoticesRequest) {
            return axios.get('/partner-notices', GetPartnerNoticesRequest);
        },
        postPartnerNotices: function (PostPartnerNoticesRequest) {
            return axios.post('/partner-notices', PostPartnerNoticesRequest.data);
        }
    };
};
